<template>
  <div class="opage">
    <div>
      <!-- 意见反馈列表 -->
      <baseBreadcrumb :page="$t('message.feedback')" :menu="$t('message.operationAndMaintenance')" />
      <!-- 状态筛选 -->
      <div class="tabs">
        <!-- 意见反馈 -->
        <div class="item" :class="{ isLogin: isLogin }" @click="isLogin = true">
          {{ $t('message.feedback') }}
        </div>
        <!-- 网站咨询 -->
        <div class="item" :class="{ isLogin: !isLogin }" @click="isLogin = false">
          {{ $t('message.websiteConsultation') }}
        </div>
      </div>
    </div>
    <!-- 已登录 -->
    <alreadyLoggedIn v-if="isLogin" />
    <!-- 未登录 -->
    <notLogIn v-if="!isLogin" />
  </div>
</template>
<script>
import alreadyLoggedIn from './alreadyLoggedIn'
import notLogIn from './notLogIn'
export default {
  data() {
    return {
      isLogin: true,
    };
  },

  components: { alreadyLoggedIn, notLogIn },
  created() {

  },
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.tabs {
  display: flex;
  margin-bottom: 20px;

  .item {
    width: 200px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    background-color: #f5f5f5;
    cursor: pointer;
  }

  .isLogin {
    color: #FFFFFF;
    background-color: #B4272D
  }
}
</style>